import { render, staticRenderFns } from "./WelderTestListForExpiryExtend.vue?vue&type=template&id=6942ff82"
import script from "./WelderTestListForExpiryExtend.vue?vue&type=script&lang=js"
export * from "./WelderTestListForExpiryExtend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports